import React, {useState} from 'react';
import FaiBox from "../../../MuiComponents/FaiBox";
import FaiTypography from "../../../MuiComponents/FaiTypography";
import theme from "../../../assets/theme";
import {Grid, Tab, Tabs} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import CreateSale from "./component/CreateSale";
import OngoingSales from "./component/OngoingSales";

function Sales() {
    const {typography, palette, borders} = theme;
    const [tabValue, setTabValue] = useState<number>(0);

    const handleSetTabValue = (event, newValue) => {
        console.log(newValue)
        setTabValue(newValue);
    }

    const tabContentComponents: JSX.Element[] = [<CreateSale/>, <OngoingSales/>];


    return (
        <>

            <FaiBox>
                <FaiBox className={"sales-title"} mb={"21px"}>
                    <FaiTypography variant={"h4"} fontWeight={typography.fontWeightMedium}>
                        Sales
                    </FaiTypography>
                </FaiBox>
                <FaiBox className={"sales-body"}>
                    <FaiBox bgColor={"white"} p={1}>
                        <Grid container>
                            <Grid item md={3} sm={3}>
                                <AppBar position="static" sx={{boxShadow: "none !important"}}>
                                    <Tabs orientation={"horizontal"} value={tabValue} onChange={handleSetTabValue}>
                                        <Tab
                                            label="New Sales"
                                        />
                                        <Tab
                                            label="Ongoing sales"
                                        />
                                    </Tabs>
                                </AppBar>
                            </Grid>
                        </Grid>
                    </FaiBox>
                    <FaiBox className={"sales-tab-content"}>
                        <FaiBox mt={"21px"} mb={"21px"}>
                            {tabContentComponents[tabValue]}
                        </FaiBox>
                    </FaiBox>
                </FaiBox>
            </FaiBox>


        </>
    );
}

export default Sales;
